export enum TraversalDirection {
  Row,
  Column,
}

export const SlideShowSpeeds = {
  0: 250,
  1: 500,
  2: 1000,
  3: 2000,
  4: 4000,
};

export const SlideShowChangeIntervals = {
  'Very Slow': 0,
  'Slow': 1,
  'Medium': 2,
  'Fast': 3,
  'Very Fast': 4,
}

export const sidePanelButtonsActiveIconColor = 'white';
export const sidePanelButtonsInActiveIconColor = '#313131';

export const sidePanelButtonsActiveButtonColor = '#313131';
export const sidePanelButtonsInActiveButtonColor = 'white';

export const sidePanelButtonsActiveBorderColor = '#313131';
export const sidePanelButtonsInActiveBorderColor = '#B4B4B4';
